import { unitMapping } from '#src/lib/style.ts';

type Props = {
  className?: string;
  size?: keyof typeof unitMapping;
  color?: string;
};
export const NBABall = ({ className, size = 2, color }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      fill="none"
      style={{
        width: unitMapping[size],
        height: unitMapping[size],
      }}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.53348 0.688668C2.03584 0.32431 2.63139 0.0805811 3.2776 0V3.2776H2.31515C2.23577 2.21891 1.90083 1.36135 1.56649 0.748409C1.55549 0.728236 1.54448 0.708323 1.53348 0.688668ZM1.36719 3.2776C1.29837 2.49969 1.06815 1.85311 0.821145 1.36142C0.383443 1.89748 0.0899885 2.55594 0 3.2776H1.36719ZM5.68838e-07 4.22241H1.36719C1.29837 5.00031 1.06815 5.64689 0.821145 6.13858C0.383444 5.60252 0.0899897 4.94406 5.68838e-07 4.22241ZM2.31515 4.22241H3.2776V7.5C2.63139 7.41942 2.03584 7.17569 1.53348 6.81133C1.54448 6.79168 1.55549 6.77176 1.56649 6.75159C1.90083 6.13865 2.23577 5.28109 2.31515 4.22241ZM4.22241 4.22241V7.5C4.86862 7.41942 5.46416 7.17569 5.96652 6.81133C5.95552 6.79167 5.94451 6.77175 5.93351 6.75158C5.59918 6.13864 5.26423 5.28108 5.18485 4.22241H4.22241ZM6.13281 4.22241C6.20164 5.00031 6.43185 5.64689 6.67886 6.13858C7.11656 5.60252 7.41001 4.94406 7.5 4.22241H6.13281ZM7.5 3.2776H6.13281C6.20163 2.49969 6.43184 1.85311 6.67885 1.36141C7.11656 1.89747 7.41001 2.55594 7.5 3.2776ZM5.18485 3.2776H4.22241V0C4.86861 0.0805808 5.46415 0.324308 5.96651 0.688663C5.95551 0.708314 5.94451 0.728225 5.93351 0.748395C5.59917 1.36134 5.26423 2.21891 5.18485 3.2776Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};
